import React from 'react';
import { ButtonProps } from './Button';
import { ButtonSideIcon } from './ButtonIcon.styles';

type ButtonContentWrapperProps = Pick<ButtonProps, 'icon' | 'iconPosition' | 'children' | 'size'>;

const ButtonContentWrapper = ({ icon, iconPosition, children, size }: ButtonContentWrapperProps): JSX.Element => {
  if (!children && icon) {
    return <>{icon}</>;
  }

  return (
    <>
      {icon && iconPosition === 'left' && (
        <ButtonSideIcon
          $size={size}
          $iconPosition={iconPosition}
        >
          {icon}
        </ButtonSideIcon>
      )}
      <span>{children}</span>
      {icon && iconPosition === 'right' && (
        <ButtonSideIcon
          $size={size}
          $iconPosition={iconPosition}
        >
          {icon}
        </ButtonSideIcon>
      )}
    </>
  );
};

export default ButtonContentWrapper;
